// HowToTrade.tsx

import * as React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogOverlay,
  DialogPortal,
} from "./ui/dialog";
import { Lock } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../components/ui/carousel";
import { Button } from "../components/ui/button";
import buySellIcon from "../assets/images/purchase.png";
import sendReceiveIcon from "../assets/images/sentCrypto.png";
import welcomeIcon from "../assets/images/welcome.svg";
import eightyEightPayIcon from "../assets/images/paymentMade.png";
import withdrawAndDeposit from "../assets/images/depositMade.png";

const HowToTrade = ({ open, setOpen, setActiveTab }) => {
  const carouselSteps = [
    {
      icon: welcomeIcon,
      title: "Welcome to Your Wallet",
      description: "Here's how to manage and grow your assets in one place.",
      btnText: "Explore Digital Wallet",
      activeTab: "overview",
    },
    {
      icon: withdrawAndDeposit,
      title: "Deposit & Withdraw Funds",
      description:
        "Deposit or withdraw money seamlessly to get started with your financial journey.",
      btnText: "Withdraw funds",
      activeTab: "withdraw-deposit",
    },
    {
      icon: buySellIcon,
      title: "Buy & Sell Crypto",
      description:
        "Easily trade digital currencies directly within your wallet",
      btnText: "Buy Crypto",
      activeTab: "buy-sell",
    },
    {
      icon: sendReceiveIcon,
      title: "Send & Receive Crypto",
      description:
        "Transfer crypto assets quickly and securely to anyone, anywhere.",
      btnText: "Send Crypto",
      activeTab: "send-receive",
    },
    {
      icon: eightyEightPayIcon,
      title: "Instant Payments with 88 Pay",
      description:
        "Send and receive fiat instantly with other 88 users—fast, secure, and hassle-free.",
      btnText: "Instantly Pay",
      activeTab: "80eightpay",
    },
  ];
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogPortal>
        <DialogOverlay className="bg-brand-primary/45 backdrop-blur-[4px] fixed inset-0" />

        {/* Trigger Button */}
        <DialogTrigger asChild></DialogTrigger>

        {/* Dialog Content */}
        <DialogContent
          className="max-w-[800px] rounded-lg p-4"
          aria-describedby="carousel-description"
        >
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold flex justify-center items-center">
              {"How to use your Digital Wallet"}
            </DialogTitle>
          </DialogHeader>

          {/* Carousel Content */}
          <div id="carousel-description" className="mt-4">
            <Carousel className="w-full max-w-[650px] mx-auto">
              <CarouselContent>
                {carouselSteps.map((step, index) => (
                  <CarouselItem key={index}>
                    <div className="p-2">
                      <div className="w-full max-w-5xl  p-12 flex flex-col items-center text-center">
                        {/* Success Image */}
                        <img
                          src={step.icon}
                          alt={step.icon}
                          width={150}
                          height={150}
                          className="mb-6"
                        />

                        {/* Step Title */}
                        <h2 className="text-2xl font-bold text-purple-700 mb-4">
                          {step.title}
                        </h2>
                        {/* Step Description */}
                        <p className="text-lg font-normal text-gray-600 mb-10">
                          {step.description}
                        </p>

                        {/* Done Button */}
                        <Button
                          onClick={() => {
                            setActiveTab(step.activeTab);
                            setOpen(false);
                          }}
                          className="w-1/2 p-2 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold"
                        >
                          {step.btnText}
                        </Button>

                        {/* Bottom Lock Label */}
                        <div className="flex items-center justify-center gap-1 text-sm text-gray-500 mt-6">
                          <Lock size={12} />
                          <p>Secured by 80Eight</p>
                        </div>
                      </div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};

export default HowToTrade;
